

import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import {
  Box,
  Typography,
  Card,
  Skeleton,
} from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";

/* ================= CUSTOM ARROWS ================= */

function NextArrow({ onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: "absolute",
        right: { xs: "-5px", md: "-15px" },
        top: "50%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        zIndex: 20,
      }}
    >
      <img src="/assets/images/right_arrow.png" alt="next" width={35} />
    </Box>
  );
}

function PrevArrow({ onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: "absolute",
        left: { xs: "-5px", md: "-15px" },
        top: "50%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        zIndex: 20,
      }}
    >
      <img src="/assets/images/left_arrow.png" alt="prev" width={35} />
    </Box>
  );
}

/* ================= Main Component================= */

export default function RentalLocation({
  address = "",
  nearbyLocations = [],
  amenity = [],
}) {
  const theme = useTheme();

  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  const [slidesToShow, setSlidesToShow] = useState(1);

  const safeAmenity = Array.isArray(amenity) ? amenity : [];
  const safeNearby = Array.isArray(nearbyLocations) ? nearbyLocations : [];

  /* ---------- Responsive slides ---------- */
  useEffect(() => {
    if (isXs) setSlidesToShow(1);
    else if (isSm) setSlidesToShow(2);
    else if (isMdUp) setSlidesToShow(3);
  }, [isXs, isSm, isMdUp]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <Box
      sx={{
        width: "100%",
        backgroundImage: "url(/assets/images/plootbg.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        py: { xs: 4, md: 6 },
      }}
    >
      {/* ================= HEADER ================= */}
      <Box
        sx={{
          px: { xs: 2, md: 5 },
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <img
          src="/assets/icons/routing.png"
          alt="location"
          style={{ width: 90 }}
        />

        <Box>
          <Typography variant="body1" sx={{ opacity: 0.8 }}>
            Property Location
          </Typography>

          <Typography
                     variant="h6"
                     fontWeight={{ xs: 200, md: 400 }}
                     sx={{
                       lineHeight: 1.3,
                       fontSize: { xs: 12, sm: 14, md: 16 },
                     }}
                   >
                     {address || ""}
                   </Typography>
        </Box>
      </Box>

      {/*NEARBY AMENITIES*/}

      <Box sx={{ px: { xs: 2, md: 5 }, mt: 3 }}>
        <Typography sx={{ color: "#608900", fontWeight: 600 }}>
         Amenities around this plot properties
        </Typography>
      </Box>

      <Box sx={{ position: "relative", mt: 3, px: { xs: 1, sm: 4 } }}>
        {safeAmenity.length === 0 ? (
          <Box
            sx={{
              minHeight: 160,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography color="text.secondary" fontWeight={600}>
              No Amenities Found
            </Typography>
          </Box>
        ) : (
          <Slider {...settings}>
            {safeAmenity.map((item) => (
              <Box key={item.id} sx={{ px: 2 }}>
                <Card sx={{ p: 3, borderRadius: 3 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Box
                      component="img"
                      src={item?.image}
                      alt={item?.title}
                      sx={{
                        width: 55,
                        height: 55,
                        objectFit: "contain",
                        borderRadius: "50%",
                        border: "1px solid #e0e0e0",
                        p: 1,
                      }}
                    />

                    <Typography fontWeight={600} fontSize={15}>
                      {item?.title}
                    </Typography>
                  </Box>
                </Card>
              </Box>
            ))}
          </Slider>
        )}
      </Box>

      {/*NEARBY LOCATION*/}

      <Box sx={{ px: { xs: 2, md: 5 }, mt: 5 }}>
        <Typography sx={{ color: "#608900", fontWeight: 600 }}>
          Nearby Location
        </Typography>
      </Box>

      <Box sx={{ position: "relative", mt: 3, px: { xs: 1, sm: 4 } }}>
        {safeNearby.length === 0 ? (
          <Box
            sx={{
              minHeight: 160,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography color="text.secondary" fontWeight={600}>
              No Location Found
            </Typography>
          </Box>
        ) : (
          <Slider {...settings}>
            {safeNearby.map((item, index) => (
        <Box key={index} sx={{ px: 2 }}>
          <Card sx={{ p: 3, borderRadius: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              
              {/* ICON */}
              <Box
                component="img"
                src={item?.image}
                alt={item?.title}
                sx={{
                  width: 55,
                  height: 55,
                  objectFit: "contain",
                  borderRadius: "50%",
                  border: "1px solid #e0e0e0",
                  p: 1,
                }}
              />

              {/* title +km */}
              <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography fontWeight={600} fontSize={15}>
                      {item?.title}
                    </Typography>

                <Typography fontWeight={400} fontSize={14} color="text.secondary">
                 {/* {item?.pivot?.distance} km */}
                   {parseFloat(item?.pivot?.distance)} km
                </Typography>
              </Box>

            </Box>
          </Card>
        </Box>
      ))}
          </Slider>
        )}
      </Box>
    </Box>
  );
}
